import { RecordValues } from '../common';

export const COUNTRY_ECOTAX_TYPE = {
  NOT_DISPLAYED: 1,
  INCLUDED_IN_TYRE: 2,
  ON_SERVICE_LINE: 3,
} as const;
export type ICountryEcotaxType = RecordValues<typeof COUNTRY_ECOTAX_TYPE>;
